import { RuleInputSchemaTypeEnum } from '../../enums/rules/RuleInputSchemaTypeEnum';

export const INPUT_SCHEMA_NAMES: Record<RuleInputSchemaTypeEnum, string> = {
  [RuleInputSchemaTypeEnum.Ecomm]: 'Ecomm',
  [RuleInputSchemaTypeEnum.KittFinco]: 'Kitt Finco',
  [RuleInputSchemaTypeEnum.Contract]: 'Contract',
  [RuleInputSchemaTypeEnum.EcomFinco]: 'Ecom Finco',
};
